let parseBoolean = function (obj) {
  "use strict";
  
  if (typeof obj === 'undefined') {
    return false;
  }
  if (obj === true || obj === false) {
    return obj;
  }
  obj = obj.toString().toLowerCase();
  if (obj) {
    switch (obj) {
      case '0':
        return false;
      case 'true':
      case 'on':
      case 'yes':
        return true;
    }
  }
  return false;
};

module.exports = parseBoolean;


// WEBPACK FOOTER //
// ./app.v2/assets/js/parseBoolean.js